import axios from 'axios';

import config from '../common/config';

const resolveLanguageParam = () => {
  try {
    const savedLanguage = localStorage.getItem('selectedLanguage');
    return savedLanguage === 'en' ? 'english' : 'hebrew';
  } catch (error) {
    return 'hebrew';
  }
};

export default {
  getAttraction(token, attractionId, sorce) {
    const language = resolveLanguageParam();
    return axios.get(`${config.config.ROOT_URL}/attraction_api/${attractionId}/${sorce}?language=${language}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    });
  },
  
  updateAttraction( token, attractionId, attractionInfo)
  {
    const formData = new FormData()
    formData.append('data', JSON.stringify(attractionInfo));
    return axios.post(`${config.config.ROOT_URL}/update_attraction_api/${attractionId}`,formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data'        }
    });
  },

  getPlaceAiInformation( token, attractionId, attractionInfo)
  {
    const formData = new FormData()
    formData.append('data', JSON.stringify(attractionInfo));
    return axios.post(`${config.config.ROOT_URL}/get_place_ai_information`,formData, {
      headers: {
        'Authorization': `Bearer ${token}`,
        'content-type': 'multipart/form-data'        }
    });
  },

  requestAttractionEnrichment(token, { title, address, text }) {
    return axios.post(
      `${config.config.ROOT_URL}/get_attraction_enrichment_api`,
      { title, address, text },
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },

  enrichManagerAttractions(token) {
    return axios.post(
      `${config.config.ROOT_URL}/enrich_manager_attractions_api`,
      {},
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },

  readAttractionEnrichment(token, attractionId) {
    return axios.get(
      `${config.config.ROOT_URL}/attraction_enrichment_api/${attractionId}`,
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },

  saveAttractionEnrichment(token, attractionId, enrichment) {
    return axios.post(
      `${config.config.ROOT_URL}/save_attraction_enrichment_api/${attractionId}`,
      enrichment,
      { headers: { Authorization: `Bearer ${token}` } },
    );
  },

  getJobStatus(token, jobId) {
    return axios.get(`${config.config.ROOT_URL}/job_status/${jobId}`, {
      headers: { Authorization: `Bearer ${token}` },
    });
  },
};
